<template>
  <div class="tindexApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="list">
    <div style="height:15px"></div>
      <ul>
        <li v-for="(item,i) in scenic" @click="toPush(item.id,'tkdetail?uid='+uid)" :style="i <= 0 ? 'background:url('+tj+') no-repeat right top #fff;' : ''">
          <div class="title">
            <img :src="baseUrl+item.img[0]" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <div class="price">门票<i><b>¥</b>{{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>起
              <font>营业时间：{{item.business}}</font></div>
            </div>
          </div>
          <h2>热销门票<font>{{item.level}}级景区</font><font>限时折扣</font><font>优惠门票3折起</font></h2>
          <div class="ticket" v-for="(vo,k) in item.names">
            <span><i class="el-icon-postcard"></i>{{vo[0]}}</span>
            <p>￥{{vo[1]}}<i class="el-icon-arrow-right"></i></p>
          </div>
        </li>
      </ul>
      <div class="none" v-if="scenic.length <= 0 && cityData.length != 0">
        <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
        <a @click="$router.push('citys')">切换地区</a>
      </div>
      <div style="height:60px"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        userData:[],
        scenic:[],
        baseUrl:'',
        tj:require( '../../assets/images/true.png'),
        code:'',
        uid:'',
        id:'',
        cityData:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.cityData = JSON.parse(localStorage.getItem('cCode'));
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var qrcode = this.$route.query.qrcode == undefined ? '' : '&qrcode='+this.$route.query.qrcode
          var url = encodeURIComponent('http://user.4008005216.com/main/tindex?id='+id+qrcode);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
    },
    mounted() {
      this.uid = (this.$route.query.uid == undefined ? '' : this.$route.query.uid)
      this.id = this.$route.query.id
      this.beforeMount();
      if(localStorage.getItem('userjwt') != null){
        this.getretail();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getretail:function(e){
        var that = this;
        var qrcode = this.$route.query.qrcode;
        if(qrcode == undefined){
          that.getscenic();
          return false;
        }
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/retail',
          params:{
            id:qrcode,
          }
        }).then(function(response){
          var res = response.data.data;
          if(res.user_id > 0){
            that.getscenic();
            that.uid=res.user_id;
          }else{
            that.toPush(qrcode,'tkapply');
          }
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getscenic:function(e){
        var that = this;
        var id = this.$route.query.id;
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        $.ajax({
          type:'post',
          url:that.$host+'home/index/ticketList',
          data:{
            page:1,
            limit:10,
            latitude:cCode.latitude,
            longitude:cCode.longitude,
            keywords:(cCode.key == 1 ? cCode.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.scenic = data.data
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .tindexApp {
    background:#ececec;
  }
  .tindexApp .list{
    display:block;
    overflow-y:auto;
    width:100%
  }
  .tindexApp .list ul{
    display:block;
    margin:0 auto;
    width:94%
  }
  .tindexApp .list ul li{
    display:block;
    width:100%;
    margin-bottom:15px;
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .tindexApp .list ul li .title{
    position:relative;
    width:100%;
  }
  .tindexApp .list ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .tindexApp .list ul li .title img{
    float:left;
    width:20%;
    border-radius:6px;
    margin-left:3%
  }
  .tindexApp .list ul li .title .conTitle{
    float:left;
    width:73%;
    margin-left:2%;
  }
  .tindexApp .list ul li .title .conTitle span{
    display:block;
    color:#000;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:15px;
    font-weight: 600;
  }
  .tindexApp .list ul li .title .conTitle font{
    color:#666;
    font-size:12px;
    padding-left:12px
  }

  .tindexApp .list ul li .title .conTitle .price{
    font-size: 12px;
    font-family: PingFang SC;
    color: #666;
    padding-top:15px
  }
  .tindexApp .list ul li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .tindexApp .list ul li .title .conTitle .price b{
    font-size:12px;
  }
  .tindexApp .list ul li .ticket{
    width:94%;
    margin:0 auto 1px auto;
    background:#f5f5f5;
    padding:10px 0;
    position:relative;
    border-radius:2px;
  }
  .tindexApp .list ul li .ticket span{
    display:inline-block;
    width:70%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:14px;
    color:#333;
    margin-left:2%;
  }
  .tindexApp .list ul li .ticket span i{
    font-size:20px;
    float:left;
    color:#333;
    margin-right:5px
  }
  .tindexApp .list ul li .ticket p{
    position:absolute;
    right:2%;
    top:12px;
    color:#666;
    font-size:12px
  }
  .tindexApp .list ul li .ticket p i{
    font-size:15px;
    float:right;
    margin-top:1px
  }
  .tindexApp .list ul li h2{
    width:94%;
    margin:0 auto 1px auto;
    font-size:15px;
    padding:12px 0 5px 0
  }
  .tindexApp .list ul li h2 font{
    font-weight:normal;
    font-size:12px;
    padding-left:15px;
    color:#666
  }
  .tindexApp .ticketFoot{
    position:fixed;
    bottom:0;
    left:0;
    width:100%;
    background:rgba(0,0,0,0.4);
    height:60px;
  }
  .tindexApp .ticketFoot .leftFoot{
    float:left;
    height:60px;
    width:76%;
  }
  .tindexApp .ticketFoot img{
    width:45px;
    border-radius:50%;
    float:left;
    margin:8px 0 0 4%
  }
  .tindexApp .ticketFoot p{
    float:left;
    width:75%;
    color:#fff;
    font-size:14px;
    margin-left:2%;
    margin-top:12px
  }
  .tindexApp .ticketFoot a{
    float:right;
    margin-right:4%;
    background:#4F7CFF;
    color:#fff;
    font-size:14px;
    width:75px;
    text-align:center;
    height:35px;
    line-height:35px;
    border-radius:6px;
    margin-top:12.5px
  }

  .tindexApp .none{
    width:80%;
    margin:0 auto;
    padding-top:50%
  }
  .tindexApp .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .tindexApp .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .tindexApp .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }
</style>